
let announcement_viewPortWidth = window.innerWidth;
let announcement_content = new Dom('.announcement-bar-slider .slider:not([data-timer="true"])');
let announcement_contentWidth = announcement_content?.self?.offsetWidth;
let announcement_coff = announcement_viewPortWidth / announcement_contentWidth;
let announcement_replics = announcement_coff < 1 ? 1 : Math.round(announcement_coff) + 1;

let announcement_parent = new Dom('.announcement-bar-slider');
let announcement_clone = announcement_content?.self?.outerHTML;

for (let i = 0; i < announcement_replics; i++) {
    announcement_parent.self.insertAdjacentHTML('beforeend', announcement_clone);
}

document.addEventListener("DOMContentLoaded", function() {
    const parent = document.querySelector('.announcement-bar-slider .grid');

    if(parent.dataset.timer) {
        parent.style.animationPlayState = 'paused';
        const slides = parent.querySelectorAll('.slideshow__slide');
        slides.forEach((slide) => slide.classList.add('hide'))

        timerOn();
    }

    function timerOn() {
        const countDownDateBar = "{{ section.settings.countdown_date_bar }}";

        const isTimerBar = document.querySelector('.timer');

        if(isTimerBar && countDownDateBar) {
            const secondBar = 1000,
                minuteBar = secondBar * 60,
                hourBar = minuteBar * 60,
                dayBar = hourBar * 24;
            const countDownBar = new Date(countDownDateBar).getTime();

            const x = setInterval(function() {
                function changeTimeZone(date, timeZone) {
                    if (typeof date === 'string') {
                        return new Date(date).toLocaleString('en-US', {
                            timeZone,
                        })
                    }

                    return new Date(
                        date.toLocaleString('en-US', {
                            timeZone,
                        }),
                    );
                }

                const nowBar = changeTimeZone(new Date(), 'America/Phoenix');
                const  distance = countDownBar - nowBar;


                document.querySelector('.js-timer-daysBar').innerText = insetZero(Math.floor(distance / (dayBar)));
                document.querySelector('.js-timer-hoursBar').innerText = insetZero(Math.floor((distance % (dayBar)) / (hourBar)));
                document.querySelector('.js-timer-minutesBar').innerText = insetZero(Math.floor((distance % (hourBar)) / (minuteBar)));
                document.querySelector('.js-timer-secondsBar').innerText = insetZero(Math.floor((distance % (minuteBar)) / (secondBar)));

                isTimerBar.parentNode.style.opacity = 1;

                function insetZero(el) {
                    if(el < 0) {
                        return '00';
                    }
                    else if(el < 10) {
                        return `0${el}`
                    } else {
                        return `${el}`
                    }

                }

                stopTimer();

                function stopTimer() {
                    const timerBox = document.querySelector('.wrapper[data-box-timer]');
                    const slideElements = document.querySelectorAll('.announcement-bar-slider .slideshow__slide');
                    const timerEnable = document.querySelector('.announcement-bar-slider [data-timer]');

                    const daysBar = document.querySelector('.js-timer-daysBar').innerText;
                    const hoursBar = document.querySelector('.js-timer-hoursBar').innerText;
                    const minutesBar = document.querySelector('.js-timer-minutesBar').innerText;
                    const secondsBar = document.querySelector('.js-timer-secondsBar').innerText;

                    if(daysBar === '00' && hoursBar === '00' && minutesBar === '00' && secondsBar === '00') {
                        timerBox.classList.add('hide');
                        slideElements.forEach(slide => {
                            slide.classList.remove('hide');
                        })

                        timerEnable.setAttribute('data-timer', 'false');
                        timerEnable.setAttribute('style', 'animation-play-state: play');

                        clearInterval(x);
                    }
                }

            }, secondBar)
        }
    }
})
document.addEventListener('DOMContentLoaded', async () => {
    const { detected_values } = await readUserLocation();

    const slides = document.querySelectorAll('.announcement-bar-slider .slideshow__slide');

    if(slides.length === 0) return;

    slides.forEach(slide => {
        const text_us = slide.querySelector('[data-location="us"]');
        const text_international = slide.querySelector('[data-location="international"]');

        if(detected_values?.country?.handle !== 'US') {
            text_us?.classList.add('hide');
            text_international?.classList.remove('hide');
        } else {
            text_us?.classList.remove('hide');
            text_international?.classList.add('hide');
        }
    })

    async function readUserLocation() {
        const url = '/browsing_context_suggestions.json';
        const options = {
            method: 'GET'
        }

        try {
            const response = await fetch(url, options);

            return await response.json();
        } catch (error) {
            return error;
        }
    }
})
